<template>
  <ApolloMutation
    :mutation="(gql) => deleteChapterConnectorQuery"
    :variables="{
      chapterConnectorId: connectionId,
    }"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading }">
      <v-btn
        class="rounded-xl ml-1"
        x-small
        :elevation="0"
        fab
        color="secondaryAction"
        @click="mutate()"
        :disabled="loading"
        :loading="loading"
        ><v-icon>mdi-minus</v-icon></v-btn
      >
    </template>
  </ApolloMutation>
</template>
<script>
import { chapterQueries } from "@/graphql/ChapterQueries";
export default {
  props: {
    chapterId: String,
    storyId: String,
    connectionId: String,
  },
  methods: {
    updateCache(
      store,
      {
        data: {
          deleteChapterConnector: { chapterConnector },
        },
      }
    ) {
      const normalizedId = store.identify({ id: chapterConnector.id, __typename: 'ChapterConnector'  })
      store.evict({ id: normalizedId })
      store.gc()
    },
  },
  computed: {
    deleteChapterConnectorQuery() {
      return chapterQueries.deleteChapterConnector;
    },
  },
};
</script>
